<template>
  <div class="main-image-wrapper bg-white rounded d-flex justify-content-center p-2">
    <WCImage
      :imageSrc="imageSrc"
      :imageAlt="alt"
      defaultClass="w-100 h-100"
      :defaultTitle="defaultTitle"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import WCImage from '@/components/WCImage/WCImage.vue';

/**
 * Image with box shadow.
 * @displayName ImageWithShadow
 */
export default defineComponent({
  components: { WCImage },
  props: {
    /**
     * The image url to be rendered
     */
    imageSrc: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    defaultTitle: {
      type: String,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-img--carousel-fixed-size {
  height: rem(300px);
  width: calc(100% - 3rem);
}
.wc-img--full-size {
  height: rem(300px);
  width: 100%;
}
.wc-img-desktop--full-size {
  height: rem(400px);
  width: 100%;
}
.main-image-wrapper {
  box-shadow: 0px 3px 6px #00000029;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>
